<template>
<v-container id="main">
<v-row id="row" justify="center" >
      <v-col md="6">
        <v-card
        id="cards" 
        outlined
        class="white main--text pa-2" 
        rounded="xl" 
        align="center"
        height="100%"
        width="100%"
        elevation="15"
        >
        <v-col>
          <h3> Skip bins </h3>
          <p> 2 Cube - 6 Cube Skip Bins </p>
          <img src="@/assets/Skip bins.svg" alt="Skip bins">
        </v-col>
        </v-card>
      </v-col>
       <v-col md="6">
        <v-card
        id="cards" 
        outlined
        class="main--text white pa-2"  
        rounded="xl"
        height="100%" 
        width="100%"
        align="center"
        elevation="20"
        
        >
        <v-col>
        <h3> Roro Bins </h3>
        <p> 8 Cube - 30 Cube Roro bins </p>
        <img src="@/assets/Roro.svg" alt="Roro bins">
        </v-col>    
        </v-card>
      </v-col>
  </v-row>
  <v-row id="row" justify="center">
      <v-col md="6">
        <v-card
        id="cards" 
        outlined
        class="main--text white pa-2"  
        rounded="xl" 
        align="center"
        height="100%"
        width="100%"
        elevation="15"
        >
        <v-col>
        <h3> Tipper trucks </h3>
        <p> 1 Cube - 10 Cube trucks </p>
        <img src="@/assets/tippertruck.svg" alt="Tipper trucks">
        </v-col>
        </v-card>
      </v-col>
  </v-row>
</v-container>
</template>

<script>
export default {
  name: 'serviceType',
}
</script>

<style scoped>
@media only screen and (max-width: 580px){
 #row{
   display: block;
 }
}
</style>
